import { Controller } from "@hotwired/stimulus";
import { initializeCarousels } from "../external/carousel_initializer";

// Connects to data-controller="inapp-partial"
export default class extends Controller {
  // Clean up carousels before Turbo caches the page
  disconnect() {
    // Skip destroy during multi-slider reorder — the reorder controller
    // handles carousel teardown/reinit itself
    if (this.element.closest('[data-reordering="true"]')) return

    // Only clean up carousels within this element
    const carousels = this.element.querySelectorAll('.carousel')
    carousels.forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') {
        // Find and destroy the associated slider
        if (window.carousels && window.carousels.length > 0) {
          const sliderIndex = window.carousels.findIndex(s => s.selector === carousel)
          if (sliderIndex !== -1) {
            window.carousels[sliderIndex].destroy()
            window.carousels.splice(sliderIndex, 1)
          }
        }
        carousel.dataset.carouselInitialized = 'false'
      }
    })
  }

  // Actions to do everytime the Inapp View is re-rendered
  connect() {
    let hasCarousel = this.element.querySelector('.carousel')
    if(hasCarousel) {
      initializeCarousels('.carousel', this.element)
    }
    // Skip init on Multi-Inapp tree page
    if(this.element.closest('.tree-branch') === null){
      setTimeout(() => {
        document.dispatchEvent(new Event("initElementSelection"))
        document.dispatchEvent(new Event("initSortable"))
        document.dispatchEvent(new Event("initVideo"))
        document.dispatchEvent(new Event('rerenderCarousels')) // Re-renders the carousel / fix width
      }, 100)
    }
  }
}
